import React from 'react';
import R from 'ramda';
import injectSheet from 'react-jss';
import { FlatButton, RaisedButton, Paper, Avatar } from 'material-ui';
import EZLoadOffer from './dialog/ezload-offer';
import { toLaxTitleCase } from 'titlecase';

const PageHeader = props => {
  const {
    classes,
    email,
    userId,
    viewAs,
    openDialog,
    companyType,
    hashToken,
    country,
    ratesOrRequests,
    scheduleDemo,
    templates,
    inDLQ,
    ezLoadOfferOpen,
    toggleOffer,
    senderAvatar,
    senderCompanyName,
  } = props;
  const defaultPayloadForSignUp = {
    type: 'signup',
    viewAs,
    country,
  };
  const hasAccount = Boolean(userId);
  const wrongAccountType = Boolean(companyType && viewAs !== companyType);
  const signUpFn = () => {
    if (wrongAccountType) {
      openDialog({ ...defaultPayloadForSignUp, hashToken, preconfirmed: false, wrongAccountType });
    } else {
      openDialog({ ...defaultPayloadForSignUp, signupEmail: email, preconfirmed: true });
    }
  };
  const openEzLoadWizardFn = () => {
    const defaultPL = {
      type: 'dl-wizard',
      viewAs,
      country,
      allRequests: props.requests.length === 1 ?
      props.requests.map(obj => ({ ...obj, checked: true }))
      : props.requests,
    };
    if (wrongAccountType) {
      openDialog({ ...defaultPL, hashToken, preconfirmed: false, wrongAccountType });
    } else {
      openDialog({ ...defaultPL, signupEmail: email, preconfirmed: true });
    }
  };
  const loginFn = () => {
    if (wrongAccountType) {
      openDialog({ type: 'login', viewAs, routeToConsolidation: true, wrongAccountType });
    } else if (hasAccount) {
      openDialog({ type: 'login', loginEmail: email, viewAs });
    } else {
      openDialog({ type: 'login', associateEmail: email, viewAs });
    }
  };
  return (
    <div>
      <div className={classes.topContainer}>
      {
        viewAs === 'Contractor' ?
          (
            <div className={classes.topHeaderLeft} data-cy="buyer-header">
              <div className={classes.mainHeader}>
                {
                  senderAvatar ? (
                    <Avatar size={60} src={senderAvatar}/>
                  ) : (
                    <Avatar size={60}>{R.head(senderCompanyName || '')}</Avatar>
                  )
                }&nbsp;&nbsp;&nbsp;
                <h4>{senderCompanyName}</h4>
              </div>
              <div className={classes.mainCopy}>
                The rates below use TourConnect’s universal format to ensure you have all of the information you need. To keep everyone up-to-date, notifications will be sent out when these rates have been actioned.
                <br/>
                <br/>
                <i>{toLaxTitleCase(ratesOrRequests)} prepared for: {email}</i>
              </div>
            </div>
          ) : (
            <div className={classes.topHeaderLeft} data-cy="supplier-header">
              <h4 className={classes.mainHeader}>
                Welcome! Please respond to the contract requests below at your earliest convenience.
              </h4>
              <div className={classes.mainCopy}>
                The requests below use TourConnect's universal format to ensure you have included all of the information needed to sell your products. To keep everyone up-to-date, notifications will be sent out when these rates have been actioned.
                <br/>
                <br/>
                <i>The contract requests below were sent to: {email}</i>
              </div>
            </div>
          )
      }
      {
        (() => {
          if (hasAccount && !wrongAccountType) {
            return (
              <Paper className={classes.topHeaderRight}>
                <h4 style={{ marginBottom: '4px' }}>Log in to view these {ratesOrRequests} in your TourConnect account!</h4>
                {
                  Boolean(templates && templates.length && viewAs === 'Supplier')
                  ? (
                      <div>
                        You’ve loaded rates before!  Log in to review, adjust, and send the rates you already have in your account!
                        <div>It only takes a couple of minutes to update rates in your account for a specific buyer.</div>
                      </div>
                    )
                  : (<span>Managing {ratesOrRequests} in your TourConnect account gives you full access to enhanced contracting features.</span>)
                }
                <div className={classes.wayRight}>
                  <RaisedButton
                    data-cy="goto-contract-list"
                    labelStyle={{ textTransform: 'none' }}
                    label="Log In"
                    secondary
                    onTouchTap={loginFn}
                  />
                </div>
                <div className={classes.wayRight}>Need help? Want to learn more?&nbsp;
                  <a className={classes.a} href="#" onClick={scheduleDemo}>Schedule a brief walk-through of your account</a>
                </div>
              </Paper>
            );
          }
          return (
            <Paper className={classes.topHeaderRight} data-cy="noAccount-buttons">
              <div className={classes.signUpLogInBtnsDiv}>
                <div className={classes.btnBox}>
                  {viewAs === 'Supplier' ? 'Manage rates in\n' : 'Manage rates in\n'} a new account
                  <br/>
                  <RaisedButton
                    style={{ marginTop: '8px' }}
                    labelStyle={{ textTransform: 'none' }}
                    label="Sign Up"
                    onTouchTap={signUpFn}
                    secondary
                    data-cy="createAccountCTA"
                  />
                </div>
                <div className={classes.btnBox}>
                  {viewAs === 'Supplier' ? 'Respond to requests in\n' : 'Add rates to\n'} an existing account
                  <br/>
                  <FlatButton
                    style={{ border: '1px solid #00bcd4', marginTop: '8px' }}
                    labelStyle={{ textTransform: 'none' }}
                    label="Log In"
                    onTouchTap={loginFn}
                    secondary
                    data-cy="loginCTA"
                  />
                </div>
              </div>
              <div className={classes.wayRight}>or <a className={classes.a} href="#" onClick={scheduleDemo}>request a brief demo</a></div>
            </Paper>
          );
        })()
      }
     </div>
      {
        viewAs === 'Supplier' && (
          <div className="flex-tc-sb" style={{ marginTop: '8px' }}>
            <div className={classes.ezLoad}>
              {
                inDLQ ? (
                  <b>
                    We have already received a request to load your rates. Please check your email for update notifications from <a href="mailto:support@tourconnect.com">support@tourconnect.com</a>. If you have any other questions, please do not hesitate to ask.
                  </b>
                ) : (
                  <div/>
                )
                //   <div className={`flex-tc-sb ${classes.offerBanner}`}>
                // <span style={{ color: '#fff' }}>
                // Limited Time Offer: Free Rate Loading
                // </span>
                // <div>
                // <SmallRaisedButton
                // label="View Offer"
                // labelStyle={{ color: '#607d8b', fontWeight: 'bold', padding: '8px', top: 0 }}
                // onTouchTap={toggleOffer}
                // />
                // </div>
                // </div>
              }
            </div>
            <RaisedButton
              label="Send Rates"
              secondary
              onTouchTap={toggleOffer}
            />
          </div>
        )
      }
      <EZLoadOffer
        open={ezLoadOfferOpen}
        onRequestClose={toggleOffer}
        openSendRatesWizardFn={() => {
          toggleOffer();
          openDialog({
            type: 'send-rates',
            allRequests: props.requests.length === 1 ?
              props.requests.map(obj => ({ ...obj, checked: true }))
              : props.requests,
          });
        }}
        openEzLoadWizardFn={() => {
          toggleOffer();
          openEzLoadWizardFn();
        }}
      />
    </div>
  );
}

const styles = {
  topContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  topHeaderLeft: {
    width: '55%',
    padding: '0 24px',
  },
  mainHeader: {
    fontWeight: 'bold',
    lineHeight: '32px',
    color: 'rgba(0, 0, 0, 0.84)',
    display: 'flex',
  },
  mainCopy: {
    padding: '16px 0',
    width: '90%',
    fontSize: '14px',
  },
  wayRight: {
    display: 'block',
    textAlign: 'right',
    paddingRight: '8px',
    marginTop: '8px',
    whiteSpace: 'nowrap',
  },
  topHeaderRightHasAccount: {
    width: '45%',
    padding: '16px',
  },
  topHeaderRight: {
    borderRadius: '5px',
    width: '45%',
    padding: '8px 32px',
    paddingBottom: '16px',
    marginTop: '16px',
    fontSize: '16px',
    fontWeight: '300',
  },
  signUpLogInBtnsDiv: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '90%',
    margin: 'auto',
    marginTop: '16px',
  },
  btnBox: {
    backgroundColor: '#efefef',
    borderRadius: '5px',
    padding: '24px',
    textAlign: 'center',
    width: '45%',
    whiteSpace: 'pre-wrap',
  },
  a: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  ezLoad: {
    width: '50%',
  },
  offerBanner: { backgroundColor: '#607d8b', borderRadius: '4px', padding: '8px 12px' },
  // alreadyHaveAccount: {
  //   backgroundColor: '#efefef',
  //   width: '70%',
  //   padding: '16px',
  //   '@media (max-width: 1200px)': {
  //     width: '100%',
  //   }
  // },
};

export default injectSheet(styles)(PageHeader);



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/page-header.jsx